import { ShieldOff } from "lucide-react";

export default function EdrConsole() {
  return (
    <div style={{ minHeight:"100vh", background:"var(--t-page, #111b2f)", display:"grid", placeItems:"center", fontFamily:"'Inter', sans-serif" }}>
      <div style={{ textAlign:"center", padding:40 }}>
        <ShieldOff size={48} color="#475569" style={{ marginBottom:16 }}/>
        <h2 style={{ color:"#cbd5e1", margin:"0 0 8px", fontSize:20, fontWeight:600 }}>EDR Console — Offline</h2>
        <p style={{ color:"#64748b", fontSize:13, maxWidth:400, margin:"0 auto" }}>
          The MIDTC EDR service is temporarily paused. Endpoint detection and response
          features will return in a future update.
        </p>
      </div>
    </div>
  );
}
